import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7de82eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_container" }
const _hoisted_2 = { class: "main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "company-header-right" }
const _hoisted_8 = { class: "ion-activatable ripple-parent header-right-inner" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "star",
  src: "/assets/icon/star_b.png"
}
const _hoisted_11 = {
  key: 1,
  class: "star",
  src: "/assets/icon/star_g.png"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_13 = {
  id: "company__topContainer",
  class: "top-container"
}
const _hoisted_14 = { class: "company-info" }
const _hoisted_15 = { class: "info-left" }
const _hoisted_16 = { class: "info-logo" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_19 = { class: "info-right" }
const _hoisted_20 = { class: "title_20B" }
const _hoisted_21 = { class: "value main_12R" }
const _hoisted_22 = { class: "green_score" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "gray_divide",
  style: {'color' : '#D9DEE8 !important'}
}, "|", -1))
const _hoisted_24 = {
  key: 0,
  class: "right_btn_w",
  src: "/assets/icon/btn_right_w.png",
  srcset: "/assets/icon/btn_right_w@2x.png 2x,/assets/icon/btn_right_w@3x.png 3x"
}
const _hoisted_25 = {
  key: 1,
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}
const _hoisted_26 = {
  id: "company__mainTab",
  class: "main-tab"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 회사정보 ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-title" }, " 토론 ", -1))
const _hoisted_29 = { id: "info_box" }
const _hoisted_30 = {
  key: 0,
  class: "info_container"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "성장성분석 그래프")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray main_13R" }, " 총 인원수, 기업의 서비스 사용자수를 한눈에! ", -1))
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray center main_13R" }, " 이 회사의 고용, 사용자, 재무정보 등 성장지표가 궁금하다면? ", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 혁신의숲에서 자세히보기 ")
const _hoisted_36 = { class: "info_container" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_info" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "뉴스")
], -1))
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "info_container" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "회사소개")
], -1))
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "news_list" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "회사명", -1))
const _hoisted_45 = { class: "news_list" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "대표이사", -1))
const _hoisted_47 = { class: "news_list" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "사업자번호", -1))
const _hoisted_49 = { class: "news_list" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "설립일", -1))
const _hoisted_51 = { class: "news_list" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info_tag" }, "총 발행 주식수", -1))
const _hoisted_53 = { class: "info_container" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "투자정보")
], -1))
const _hoisted_55 = { class: "item_left" }
const _hoisted_56 = { class: "series" }
const _hoisted_57 = { class: "info_date gray" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "item_right" }
const _hoisted_60 = { class: "strong" }
const _hoisted_61 = { class: "info_container" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clubdeal_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "공시자료")
], -1))
const _hoisted_63 = { class: "doc_left" }
const _hoisted_64 = { class: "info_date gray" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "doc_right" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_content" }, " 모든 정보는 참고 및 정보 제공을 위한 것으로, 투자 권유를 목적으로 하지 않습니다. 제공되는 정보는 공개된 자료를 바탕으로 한 것이나 오류가 있을 수 있습니다. 리드엔젤과 엔젤리그는 제공되는 정보의 정확성을 보장하지 않으며, 제공되는 정보를 바탕으로 한 조합 참여의 결과에 대하여 책임지지 않습니다. ", -1))
const _hoisted_68 = { id: "company__clubeal_box" }
const _hoisted_69 = { class: "sell_container" }
const _hoisted_70 = { class: "sell_btn_container" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text" }, " 보유주식 팔면 수수료 0원, 100,000P 적립 ", -1))
const _hoisted_72 = ["disabled"]
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 이 회사 주식 팔기 ")
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buyBox" }, null, -1))
const _hoisted_75 = {
  key: 0,
  class: "card-clubdeal-container"
}
const _hoisted_76 = { class: "clubdeal_title" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" 참여 가능한 클럽딜 ")
const _hoisted_78 = { class: "title_18R" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray main_13R description" }, " 진행중인 클럽딜이 마감되기 전에 먼저 참여하세요 ", -1))
const _hoisted_80 = { class: "slide_container" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "medium_card" }
const _hoisted_83 = { class: "company-info" }
const _hoisted_84 = { class: "title_18B" }
const _hoisted_85 = { class: "card_info_wrap" }
const _hoisted_86 = { class: "medium_card_info" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "주당 가격", -1))
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { class: "strong" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_92 = {
  key: 1,
  class: "gray"
}
const _hoisted_93 = { class: "row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "진행률", -1))
const _hoisted_95 = { class: "strong" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_97 = {
  key: 1,
  class: "card-clubdeal-container"
}
const _hoisted_98 = { class: "clubdeal_title" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" 내가 클럽딜 열기 ")
const _hoisted_100 = { class: "title_18R" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray main_13R description" }, " 매물을 선택하면 판매자와 협의 후 클럽딜을 열 수 있어요 ", -1))
const _hoisted_102 = { class: "slide_container" }
const _hoisted_103 = { class: "medium_card" }
const _hoisted_104 = ["onClick"]
const _hoisted_105 = { class: "company-info" }
const _hoisted_106 = { class: "title_18B" }
const _hoisted_107 = { class: "card_info_wrap" }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = { class: "row" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "주당 가격", -1))
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { class: "strong" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_114 = {
  key: 1,
  class: "gray"
}
const _hoisted_115 = { class: "row_bottom" }
const _hoisted_116 = { class: "small" }
const _hoisted_117 = { class: "add-info" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "divide" }, "|")
], -1))
const _hoisted_119 = ["onClick"]
const _hoisted_120 = {
  key: 0,
  class: "heart_btn",
  src: "/assets/icon/heart_n_g.png",
  srcset: "/assets/icon/heart_n_g@2x.png 2x,/assets/icon/heart_n_g@3x.png 3x"
}
const _hoisted_121 = {
  key: 1,
  src: "/assets/icon/heart_s_g.png",
  class: "heart_btn",
  srcset: "/assets/icon/heart_s_g@2x.png 2x,/assets/icon/heart_s_g@3x.png 3x"
}
const _hoisted_122 = {
  key: 2,
  class: "card-clubdeal-container"
}
const _hoisted_123 = { class: "clubdeal_title" }
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" 진행 예정 클럽딜 ")
const _hoisted_125 = { class: "title_18R" }
const _hoisted_126 = { class: "slide_container" }
const _hoisted_127 = { class: "deal-container" }
const _hoisted_128 = { class: "medium_card" }
const _hoisted_129 = ["onClick"]
const _hoisted_130 = { class: "company-info" }
const _hoisted_131 = { class: "title_18B" }
const _hoisted_132 = { class: "card_info_wrap" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = { class: "row" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "주당 가격", -1))
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { class: "strong" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_139 = {
  key: 1,
  class: "gray"
}
const _hoisted_140 = { class: "row_bottom" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "오픈", -1))
const _hoisted_142 = ["onClick"]
const _hoisted_143 = {
  key: 0,
  class: "heart_btn",
  src: "/assets/icon/heart_n_g.png",
  srcset: "/assets/icon/heart_n_g@2x.png 2x,/assets/icon/heart_n_g@3x.png 3x"
}
const _hoisted_144 = {
  key: 1,
  src: "/assets/icon/heart_s_g.png",
  class: "heart_btn",
  srcset: "/assets/icon/heart_s_g@2x.png 2x,/assets/icon/heart_s_g@3x.png 3x"
}
const _hoisted_145 = {
  key: 3,
  class: "card-clubdeal-container"
}
const _hoisted_146 = { class: "clubdeal_title" }
const _hoisted_147 = /*#__PURE__*/_createTextVNode(" 마감된 클럽딜 ")
const _hoisted_148 = { class: "title_18R" }
const _hoisted_149 = { class: "slide_container" }
const _hoisted_150 = { class: "medium_card" }
const _hoisted_151 = { class: "company-info" }
const _hoisted_152 = { class: "title_18B" }
const _hoisted_153 = { class: "card_info_wrap" }
const _hoisted_154 = { class: "medium_card_info" }
const _hoisted_155 = { class: "row" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "가격", -1))
const _hoisted_157 = { class: "strong" }
const _hoisted_158 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_159 = { class: "row_bottom" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-title" }, "오픈", -1))
const _hoisted_161 = { class: "row_right" }
const _hoisted_162 = { class: "right_wrap" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/heart_s_g.png",
  class: "heart_btn",
  srcset: "/assets/icon/heart_s_g@2x.png 2x,/assets/icon/heart_s_g@3x.png 3x"
}, null, -1))
const _hoisted_164 = { class: "dimmed_bg" }
const _hoisted_165 = { key: 0 }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_exit",
  src: "/assets/icon/icon_exit.png"
}, null, -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title_14B" }, " EXIT 완료 ", -1))
const _hoisted_168 = [
  _hoisted_166,
  _hoisted_167
]
const _hoisted_169 = { key: 1 }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/icon_close.png",
  srcset: "/assets/icon/icon_close@2x.png 2x, /assets/icon/icon_close@3x.png 3x",
  class: ""
}, null, -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title_14B" }, " 클럽딜 마감 ", -1))
const _hoisted_172 = [
  _hoisted_170,
  _hoisted_171
]
const _hoisted_173 = {
  key: 4,
  class: "other-clubdeal-container"
}
const _hoisted_174 = { class: "clubdeal_title space-between" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "다른회사 클럽딜 ", -1))
const _hoisted_176 = { class: "title_18R" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "right_btn",
  src: "/assets/icon/btn_right.png",
  srcset: "/assets/icon/btn_right@2x.png 2x,/assets/icon/btn_right@3x.png 3x"
}, null, -1))
const _hoisted_179 = { class: "clubdeal-badge" }
const _hoisted_180 = ["onClick"]
const _hoisted_181 = { class: "logo" }
const _hoisted_182 = ["src"]
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_184 = { class: "collecting" }
const _hoisted_185 = {
  key: 5,
  class: "stock_container"
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_18B" }, "이 회사 주식 매물 ", -1))
const _hoisted_187 = { class: "title_18R" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stock_info" }, " 최저가로 등록된 매물이 먼저 매매됩니다. ", -1))
const _hoisted_189 = ["onClick"]
const _hoisted_190 = { class: "user_id" }
const _hoisted_191 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_192 = { class: "stock_status" }
const _hoisted_193 = { id: "company__board_box" }
const _hoisted_194 = { class: "board_container" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "board_tab_info" }, null, -1))
const _hoisted_196 = {
  key: 0,
  class: "write_box"
}
const _hoisted_197 = /*#__PURE__*/_createTextVNode(" 이 회사 어떤가요? ")
const _hoisted_198 = /*#__PURE__*/_createTextVNode(" 의견 작성하기 ")
const _hoisted_199 = {
  key: 1,
  class: "write_box light"
}
const _hoisted_200 = /*#__PURE__*/_createTextVNode(" 의견을 작성하시려면 ")
const _hoisted_201 = /*#__PURE__*/_createTextVNode(" 로그인> ")
const _hoisted_202 = { class: "board_list_container" }
const _hoisted_203 = { id: "company__sell_box" }
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_info" }, null, -1))
const _hoisted_205 = { class: "sell_container" }
const _hoisted_206 = { class: "sell_btn_container" }
const _hoisted_207 = { class: "info_text" }
const _hoisted_208 = ["disabled"]
const _hoisted_209 = /*#__PURE__*/_createTextVNode(" 이 회사 조합지분 팔기 ")
const _hoisted_210 = { class: "sell_btn_container" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_text" }, " 보유주식 팔면 수수료 0원, 100,000P 적립 ", -1))
const _hoisted_212 = ["disabled"]
const _hoisted_213 = /*#__PURE__*/_createTextVNode(" 이 회사 주식 팔기 ")
const _hoisted_214 = {
  key: 0,
  class: "stock_container"
}
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_18B" }, "이 회사 주식 매물 ", -1))
const _hoisted_216 = { class: "title_18R" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stock_info" }, " 최저가로 등록된 매물이 먼저 매매됩니다. ", -1))
const _hoisted_218 = ["onClick"]
const _hoisted_219 = { class: "user_id" }
const _hoisted_220 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_221 = { class: "stock_status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_star_rating_inline = _resolveComponent("star-rating-inline")!
  const _component_board_list = _resolveComponent("board-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "true" }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'헤더', 'clickContent':'뒤로가기'}); _ctx.closeModal();})
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.stockItemInfo.stockItemName), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      disabled: ~['mna','ipo'].indexOf(_ctx.stockItemInfo.companyStatus),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'관심버튼'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLike(_ctx.stockItemInfo.stockItemId))})
                    }, [
                      (_ctx.stockItemInfo.likeFlag)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : (_openBlock(), _createElementBlock("img", _hoisted_11))
                    ], 8, _hoisted_9),
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ])
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "main-center",
                style: _normalizeStyle({ 'background-color': _ctx.stockItemInfo.bgColor ? _ctx.stockItemInfo.bgColor : '#fff',
                      'color' : _ctx.stockItemInfo.fontColor ? _ctx.stockItemInfo.fontColor : '#222' })
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        src: _ctx.stockItemInfo.companyLogo ? _ctx.stockItemInfo.companyLogo : '/assets/icon/company_default_img.png',
                        onerror: "this.src='/assets/icon/company_default_img.png'",
                        class: "img-responsive img-circle"
                      }, null, 8, _hoisted_17),
                      _hoisted_18
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.stockItemInfo.stockItemName), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", null, "추정 시총 " + _toDisplayString(_ctx.numberToKorean(_ctx.stockItemInfo.currentValuation)) + "원", 1),
                      _createElementVNode("img", {
                        src: "/assets/icon/help-circle.png",
                        srcset: "/assets/icon/help-circle@2x.png 2x,/assets/icon/help-circle@3x.png 3x",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단카드', 'clickContent':'추정시가총액툴팁'}); _ctx.openPopover()})
                      })
                    ]),
                    _createElementVNode("div", {
                      class: "right-bottom main_14R",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'상단카드', 'clickContent':'토론더보기'}); _ctx.changeTab('board')})
                    }, [
                      _createVNode(_component_star_rating_inline, {
                        class: "inline",
                        value: _ctx.stockItemInfo.avgPoint
                      }, null, 8, ["value"]),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(Number(_ctx.stockItemInfo.avgPoint).toFixed(1)), 1),
                      _hoisted_23,
                      _createElementVNode("span", {
                        class: "green-label",
                        style: _normalizeStyle({ 'margin-right': _ctx.stockItemInfo.bgColor ? '10px' : '0px'})
                      }, _toDisplayString(_ctx.stockItemInfo.count) + "명 ", 5),
                      (_ctx.stockItemInfo.bgColor)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                        : (_openBlock(), _createElementBlock("img", _hoisted_25))
                    ])
                  ])
                ])
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", {
                class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'info' ? 'select' : '']]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'탭영역', 'clickContent':'회사정보'}); _ctx.changeTab('info')})
              }, [
                _hoisted_27,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["ion-activatable ripple-parent", [_ctx.activeTab === 'board' ? 'select' : '']]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'탭영역', 'clickContent':'토론'}); _ctx.changeTab('board')})
              }, [
                _hoisted_28,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ], 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_29, [
              (_ctx.stockItemInfo.ifGraphLink && _ctx.stockItemInfo.ifLink)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _hoisted_31,
                    _hoisted_32,
                    _createElementVNode("img", {
                      class: "if-graph",
                      src: _ctx.stockItemInfo.ifGraphLink
                    }, null, 8, _hoisted_33),
                    _hoisted_34,
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent g_btn",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'성장성분석 그래프', 'clickContent':'혁신의숲에서 자세히보기'}); _ctx.openLink(_ctx.stockItemInfo.ifLink);})
                    }, [
                      _hoisted_35,
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _hoisted_38,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.press, (info, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "news_list"
                  }, [
                    _createElementVNode("div", {
                      class: "ion-activatable ripple-parent",
                      onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'뉴스목록', 'clickContent': info.title}); _ctx.openLink(info.link); }
                    }, [
                      _createTextVNode(_toDisplayString(info.title) + " ", 1),
                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                    ], 8, _hoisted_39)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", {
                  class: "company_info",
                  innerHTML: _ctx.stockItemInfo.companyIntroduction
                }, null, 8, _hoisted_42),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.stockItemName), 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.ceo), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.bizno), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("span", null, _toDisplayString(_ctx.stockItemInfo.foundDate), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.stockItemInfo.totalStockAmount)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.investHistory, (info, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "news_list space-between"
                  }, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, " Series " + _toDisplayString(info.series), 1),
                      _createElementVNode("div", _hoisted_57, _toDisplayString(info.date.split('.')[0] + '.' + info.date.split('.')[1]), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "item_center",
                      innerHTML: info.investor.split('|').map((i)=>{return `<span>${i}</span>`}).join('<br/>')
                    }, null, 8, _hoisted_58),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("span", _hoisted_60, _toDisplayString(info.value), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemInfo.publicAnnouncement, (info, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "news_list space-between"
                  }, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("span", _hoisted_64, _toDisplayString(info.date), 1),
                      _createElementVNode("span", {
                        class: "ion-activatable ripple-parent info_link",
                        onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'공시자료 목록', 'clickContent': info.title}); _ctx.openLink(info.link)}
                      }, [
                        _createTextVNode(_toDisplayString(info.title) + " ", 1),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_65)
                    ]),
                    _createElementVNode("div", _hoisted_66, _toDisplayString(info.sender), 1)
                  ]))
                }), 128))
              ]),
              _hoisted_67
            ], 512), [
              [_vShow, _ctx.activeTab === 'info']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("button", {
                    class: "ion-activatable ripple-parent b_btn",
                    disabled: ~['mna','ipo'].indexOf(_ctx.stockItemInfo.companyStatus),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'팔기 상단버튼 영역', 'clickContent':'이 회사 주식 팔기'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.openSellModal())})
                  }, [
                    _hoisted_73,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_72)
                ])
              ]),
              _hoisted_74,
              (_ctx.collectingPartnerships.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.collectingPartnerships.length), 1),
                      _hoisted_79
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectingPartnerships, (deal, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: deal.partnershipId,
                          class: "slide_wrap"
                        }, [
                          _createElementVNode("div", {
                            class: "ion-activatable ripple-parent deal-container",
                            style: _normalizeStyle(_ctx.collectingPartnerships.length-1 === idx ? {'margin-right' : '20px'} : ''),
                            onClick: () =>{
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'진행중 클럽딜', 'clickContent':deal.partnershipName})
                    _ctx.useClubDealProgressModal(deal.partnershipId, 'company')
                  }
                          }, [
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("div", {
                                class: "medium_card_bg",
                                style: _normalizeStyle([deal.cardBgUrl ? {backgroundImage : `url("${deal.cardBgUrl}")`} : '""', {"color":"#fff"}])
                              }, [
                                _createElementVNode("div", _hoisted_83, [
                                  _createElementVNode("div", _hoisted_84, _toDisplayString(deal.partnershipName) + "> ", 1)
                                ])
                              ], 4),
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("div", _hoisted_86, [
                                  _createElementVNode("div", _hoisted_87, [
                                    _hoisted_88,
                                    (_ctx.hasSession())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_89, [
                                          _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                          _hoisted_91
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_92, "로그인 후 확인"))
                                  ]),
                                  _createElementVNode("div", _hoisted_93, [
                                    _hoisted_94,
                                    _createElementVNode("span", {
                                      class: _normalizeClass({
                              'red-2':deal.collectedRate*100 >= 50,
                              'sky':( deal.collectedRate*100 < 50 ),
                            })
                                    }, [
                                      _createElementVNode("span", _hoisted_95, _toDisplayString((deal.collectedRate*100).toFixed(0)), 1),
                                      _hoisted_96
                                    ], 2)
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                          ], 12, _hoisted_81)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.preparePartnerships.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _hoisted_99,
                      _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.preparePartnerships.length), 1),
                      _hoisted_101
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparePartnerships, (deal, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: deal.partnershipId,
                          class: "slide_wrap"
                        }, [
                          _createElementVNode("div", {
                            class: "deal-container",
                            style: _normalizeStyle(_ctx.collectingPartnerships.length-1 === idx ? {'margin-right' : '20px'} : '')
                          }, [
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("div", {
                                class: "ion-activatable ripple-parent medium_card_bg",
                                style: _normalizeStyle([deal.cardBgUrl ? {backgroundImage : `url("${deal.cardBgUrl}")`} : '""', {"color":"#fff"}]),
                                onClick: () =>{
                        _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'클럽딜 열기', 'clickContent':deal.partnershipName})
                        _ctx.useClubDealOpenModal(deal.partnershipId,'company')
                      }
                              }, [
                                _createElementVNode("div", _hoisted_105, [
                                  _createElementVNode("div", _hoisted_106, _toDisplayString(deal.partnershipName) + "> ", 1)
                                ]),
                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                              ], 12, _hoisted_104),
                              _createElementVNode("div", _hoisted_107, [
                                _createElementVNode("div", {
                                  class: "ion-activatable ripple-parent medium_card_info",
                                  onClick: () =>{
                          _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'클럽딜 열기', 'clickContent':deal.partnershipName})
                          _ctx.useClubDealOpenModal(deal.partnershipId,'company')
                        }
                                }, [
                                  _createElementVNode("div", _hoisted_109, [
                                    _hoisted_110,
                                    (_ctx.hasSession())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_111, [
                                          _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                          _hoisted_113
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_114, " 로그인 후 확인 "))
                                  ]),
                                  _createElementVNode("div", _hoisted_115, [
                                    _createElementVNode("div", _hoisted_116, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _createElementVNode("span", null, _toDisplayString(deal.sellerInviteCode), 1),
                                        _hoisted_118,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.prettyDateToOnemonth(deal.updateAtTime, 'channel')), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", {
                                      class: "ion-activatable ripple-parent right_wrap",
                                      onClick: _withModifiers(($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'클럽딜 열기 찜하기', 'clickContent':deal.partnershipName}); (_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.partnershipLike(deal.partnershipStatus, 'prepareDeals',deal.partnershipId))}, ["stop"])
                                    }, [
                                      (deal.partnershipLikeId)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_120))
                                        : (_openBlock(), _createElementBlock("img", _hoisted_121)),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["main_12R", {'deep-blue':deal.partnershipLikeId>0, grey:!deal.partnershipLikeId}])
                                      }, _toDisplayString(deal.likeCount), 3),
                                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                    ], 8, _hoisted_119)
                                  ]),
                                  _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                ], 8, _hoisted_108)
                              ])
                            ])
                          ], 4)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.comingSoonPartnerships.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _hoisted_124,
                      _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.comingSoonPartnerships.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_126, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comingSoonPartnerships, (deal) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: deal.partnershipId
                        }, [
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("div", {
                                class: "ion-activatable ripple-parent medium_card_bg",
                                style: _normalizeStyle([deal.cardBgUrl ? {backgroundImage : `url("${deal.cardBgUrl}")`} : '""', {"color":"#fff"}]),
                                onClick: () =>{
                        _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'진행 예정 클럽딜', 'clickContent':deal.partnershipName})
                        _ctx.useClubDealProgressModal(deal.partnershipId, 'company')
                      }
                              }, [
                                _createElementVNode("div", _hoisted_130, [
                                  _createElementVNode("div", _hoisted_131, _toDisplayString(deal.partnershipName) + " > ", 1)
                                ]),
                                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                              ], 12, _hoisted_129),
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("div", {
                                  class: "ion-activatable ripple-parent medium_card_info",
                                  onClick: () =>{
                          _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'진행 예정 클럽딜', 'clickContent':deal.partnershipName})
                          _ctx.useClubDealProgressModal(deal.partnershipId, 'company')
                        }
                                }, [
                                  _createElementVNode("div", _hoisted_134, [
                                    _hoisted_135,
                                    (_ctx.hasSession())
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_136, [
                                          _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                          _hoisted_138
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_139, " 로그인 후 확인 "))
                                  ]),
                                  _createElementVNode("div", _hoisted_140, [
                                    _createElementVNode("div", null, [
                                      _hoisted_141,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDateFrom)), 1)
                                    ]),
                                    _createElementVNode("div", {
                                      class: "ion-activatable ripple-parent right_wrap",
                                      onClick: _withModifiers(($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'진행 예정 클럽딜 찜하기', 'clickContent':deal.partnershipName}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.partnershipLike(deal.partnershipStatus, 'upcomingLeadDeals',deal.partnershipId))}, ["stop"])
                                    }, [
                                      (deal.partnershipLikeId)
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_143))
                                        : (_openBlock(), _createElementBlock("img", _hoisted_144)),
                                      _createElementVNode("span", {
                                        class: _normalizeClass({'deep_blue':deal.partnershipLikeId>0, grey:!deal.partnershipLikeId})
                                      }, _toDisplayString(deal.likeCount), 3),
                                      _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                                    ], 8, _hoisted_142)
                                  ])
                                ], 8, _hoisted_133)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.stockItemPartnershipHistories.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                    _createElementVNode("div", _hoisted_146, [
                      _hoisted_147,
                      _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.stockItemPartnershipHistories.length), 1)
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemPartnershipHistories, (deal, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: deal.partnershipId,
                          class: "slide_wrap"
                        }, [
                          _createElementVNode("div", {
                            class: "deal-container",
                            style: _normalizeStyle(_ctx.collectingPartnerships.length-1 === idx ? {'margin-right' : '20px'} : '')
                          }, [
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("div", {
                                class: "medium_card_bg",
                                style: _normalizeStyle([deal.cardBgUrl ? {backgroundImage : `url("${deal.cardBgUrl}")`} : '""', {"color":"#fff"}])
                              }, [
                                _createElementVNode("div", _hoisted_151, [
                                  _createElementVNode("div", _hoisted_152, _toDisplayString(deal.partnershipName) + "> ", 1)
                                ])
                              ], 4),
                              _createElementVNode("div", _hoisted_153, [
                                _createElementVNode("div", _hoisted_154, [
                                  _createElementVNode("div", _hoisted_155, [
                                    _hoisted_156,
                                    _createElementVNode("span", null, [
                                      _createElementVNode("span", _hoisted_157, _toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1),
                                      _hoisted_158
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_159, [
                                    _createElementVNode("div", null, [
                                      _hoisted_160,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDateFrom)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_161, [
                                      _createElementVNode("div", _hoisted_162, [
                                        _hoisted_163,
                                        _createElementVNode("span", {
                                          class: _normalizeClass({'deep_blue':deal.partnershipLikeId>0, grey:!deal.partnershipLikeId})
                                        }, _toDisplayString(deal.likeCount), 3)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_164, [
                                (deal.partnershipStatus === 'dissolution')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_165, _hoisted_168))
                                  : (deal.partnershipStatus !== 'dissolution')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_169, _hoisted_172))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ], 4)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.anotherCompanyPartnerships.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("div", null, [
                        _hoisted_175,
                        _createElementVNode("span", _hoisted_176, _toDisplayString(_ctx.anotherCompanyPartnerships.length), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent add_btn margin-right",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'다른회사 클럽딜', 'clickContent':'더보기'}); _ctx.clubDealAllOpen=true;})
                      }, [
                        _hoisted_177,
                        _hoisted_178,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_179, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.anotherCompanyPartnerships, (deal, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: deal.partnershipId,
                          class: "badge_wrap"
                        }, [
                          _createElementVNode("div", {
                            class: "badge-container",
                            style: _normalizeStyle(_ctx.anotherCompanyPartnerships.length-1 === idx ? {'margin-right' : '20px'} : ''),
                            onClick: () =>{
                    _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'다른회사 클럽딜', 'clickContent':deal.partnershipName})
                    _ctx.useClubDealProgressModal(deal.partnershipId)
                  }
                          }, [
                            _createElementVNode("div", {
                              class: "ion-activatable ripple-parent deal-badge",
                              style: _normalizeStyle({background:deal.bgColor, color:deal.fontColor})
                            }, [
                              _createElementVNode("div", _hoisted_181, [
                                _createElementVNode("img", {
                                  src: deal.companyLogo ? deal.companyLogo : '/assets/icon/company_default_img.png',
                                  onerror: "this.src='/assets/icon/company_default_img.png'",
                                  class: "img-responsive img-circle"
                                }, null, 8, _hoisted_182),
                                _hoisted_183
                              ]),
                              _createElementVNode("div", _hoisted_184, _toDisplayString(deal.partnershipName), 1),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 4)
                          ], 12, _hoisted_180)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.diplayStockItemSell.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                    _createElementVNode("div", null, [
                      _hoisted_186,
                      _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.diplayStockItemSell.length) + "건", 1)
                    ]),
                    _hoisted_188,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diplayStockItemSell, (sell) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sell.stockItemWantSellId,
                        class: "ion-activatable ripple-parent stock_item",
                        onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'이 회사 주식매물', 'clickContent':'MY매물클릭'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.showMySellItem(sell))}
                      }, [
                        _createElementVNode("span", _hoisted_190, _toDisplayString(sell.inviteCode), 1),
                        _createElementVNode("span", {
                          class: "stock_price",
                          style: _normalizeStyle({textDecoration:(sell.isMine?'underline':'')})
                        }, [
                          (_ctx.hasSession())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$filters.currency(sell.sellPrice)) + " 원 / " + _toDisplayString(_ctx.$filters.currency(sell.qty)) + " 주 ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_191
                              ], 64))
                        ], 4),
                        _createElementVNode("span", _hoisted_192, _toDisplayString(sell.info.join(' · ')), 1),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_189))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.activeTab === 'clubdeal']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_193, [
              _createElementVNode("div", _hoisted_194, [
                _hoisted_195,
                (_ctx.hasSession())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                      _hoisted_197,
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent write_btn",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'의견 작성하기', 'clickContent':'의견 작성 버튼'}); _ctx.openModal({})})
                      }, [
                        _hoisted_198,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_199, [
                      _hoisted_200,
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$global.openLoginModal()))
                      }, [
                        _hoisted_201,
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_202, [
                _createVNode(_component_board_list, {
                  "stock-item-id": _ctx.paramsId,
                  parent: "company"
                }, null, 8, ["stock-item-id"])
              ])
            ], 512), [
              [_vShow, _ctx.activeTab === 'board']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_203, [
              _hoisted_204,
              _createElementVNode("div", _hoisted_205, [
                _createElementVNode("div", _hoisted_206, [
                  _createElementVNode("div", _hoisted_207, _toDisplayString(_ctx.sellAvailableMessage), 1),
                  _createElementVNode("button", {
                    class: "ion-activatable ripple-parent w_btn",
                    disabled: _ctx.isSellAvailable === 'not-available',
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'팔기 상단버튼 영역', 'clickContent':'이 회사 조합지분 팔기'}); (_ctx.user === null ? _ctx.$global.openLoginModal(): _ctx.checkIsLinked())})
                  }, [
                    _hoisted_209,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_208)
                ]),
                _createElementVNode("div", _hoisted_210, [
                  _hoisted_211,
                  _createElementVNode("button", {
                    class: "ion-activatable ripple-parent b_btn",
                    disabled: ~['mna','ipo'].indexOf(_ctx.stockItemInfo.companyStatus),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'팔기 상단버튼 영역', 'clickContent':'이 회사 주식 팔기'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.openSellModal())})
                  }, [
                    _hoisted_213,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ], 8, _hoisted_212)
                ])
              ]),
              (_ctx.diplayStockItemSell.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                    _createElementVNode("div", null, [
                      _hoisted_215,
                      _createElementVNode("span", _hoisted_216, _toDisplayString(_ctx.diplayStockItemSell.length) + "건", 1)
                    ]),
                    _hoisted_217,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diplayStockItemSell, (sell) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sell.stockItemWantSellId,
                        class: "ion-activatable ripple-parent stock_item",
                        onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'이 회사 주식매물', 'clickContent':'MY매물클릭'}); (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.showMySellItem(sell))}
                      }, [
                        _createElementVNode("span", _hoisted_219, _toDisplayString(sell.inviteCode), 1),
                        _createElementVNode("span", {
                          class: "stock_price",
                          style: _normalizeStyle({textDecoration:(sell.isMine?'underline':'')})
                        }, [
                          (_ctx.hasSession())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$filters.currency(sell.sellPrice)) + " 원 / " + _toDisplayString(_ctx.$filters.currency(sell.qty)) + " 주 ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_220
                              ], 64))
                        ], 4),
                        _createElementVNode("span", _hoisted_221, _toDisplayString(sell.info.join(' · ')), 1),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_218))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.activeTab === 'sell']
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}